import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvailableOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/availableoption';
import { OptionPrice } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/optionprice';
import { OptionPrices } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/optionprices';
import { VehicleOption } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleoption';
import { CustomiseOptions } from 'interface';
import type { RootState } from '../store';

export const initialState: CustomiseOptions = {
  options: [],
  colours: {
    hood: [],
    paint: [],
    trim: [],
  },
};

const updateAvailableOptionPrices = (
  options: AvailableOption[],
  updatedPrices: OptionPrice[]
) => {
  options.forEach((e) => {
    const updatedPrice = updatedPrices.find((f) => f.id === e.id);

    if (updatedPrice) {
      e.price = updatedPrice.price;
      e.monthlyRentalCost = updatedPrice.monthlyRentalCost;
    }
  });
};

const updateOptionPrices = (
  options: VehicleOption[],
  updatedPrices: OptionPrice[]
) => {
  options.forEach((e) =>
    e.items.forEach((i) => {
      const updatedPrice = updatedPrices.find((f) => f.id === i.id);

      if (updatedPrice) {
        i.price = updatedPrice.price;
        i.monthlyCost = updatedPrice.monthlyRentalCost;
      }
    })
  );
};

export const finalisedOptionsSlice = createSlice({
  name: 'finalisedOptions',
  initialState: initialState,
  reducers: {
    setFinalisedState: (state, action: PayloadAction<CustomiseOptions>) => {
      state.colours = action.payload.colours;
      state.options = action.payload.options;
    },
    removeOption: (state, action: PayloadAction<number>) => {
      state
        .options!.map((value) => value.items.map((child) => child))
        .reduce(
          (previous, current) =>
            previous.concat(
              current.filter((item) => item.id === action.payload)
            ),
          []
        )
        .map((final) => (final.checked = false));
    },
    updateFinalisedOptionPrices: (
      state,
      action: PayloadAction<OptionPrices>
    ) => {
      updateAvailableOptionPrices(
        state.colours.hood,
        action.payload.colourOptionPrice.hood
      );
      updateAvailableOptionPrices(
        state.colours.paint,
        action.payload.colourOptionPrice.paint
      );
      updateAvailableOptionPrices(
        state.colours.trim,
        action.payload.colourOptionPrice.trim
      );
      updateOptionPrices(state.options, action.payload.optionPrices);
    },
  },
});

export const { setFinalisedState, removeOption, updateFinalisedOptionPrices } =
  finalisedOptionsSlice.actions;

export const finalisedOptions = (state: RootState) => state.finalisedOptions;

export default finalisedOptionsSlice.reducer;
